export default "/assets/images/live-room-screenshot.e93f20a42a07350b.webp";